export const booking_constant = [
    {
        label: "Internal Booking ID",
        key: "internal_booking_id",
    },
    {
        label: "Customer",
        key: "customer"
    },
    {
        label: "Booking Created At Date",
        key: "booking_createdAt"
    },
    {
        label: "Booking Progress in %",
        key: "booking_progress"
    },
    {
        label: "Asset Tracking",
        key: "asset_tracking"
    }
]

export const sales_constants = [
    {
        label: "Sales Order Number",
        key: "sales_order_number"
    },
    {
        label: "Sales Order Reference Number",
        key: "sales_order_reference_number"
    },
    {
        label: "Sales Order Delivery Address",
        key: "sales_order_delivery_address"
    },
    {
        label: "Sales Order Created At Date",
        key: "sales_order_createdAt"
    },
    {
        label: "Ordered Products & Qty Table",
        key: "order_product_qty_table"
    },
    {
        label: "Sales Order Progress in %",
        key: "sales_order_progress"
    },
    {
        label: "Sales Order Status",
        key: "sales_order_status"
    },
]

export const purchase_constants = [
    {
        label: "Purchase Order Number",
        key: "purchase_order_number"
    },
    {
        label: "Purchase Order Reference Number",
        key: "purchase_order_reference_number"
    },
    {
        label: "Purchase Order Delivery Address",
        key: "purchase_order_delivery_address"
    },
    {
        label: "Purchase Order Created At Date",
        key: "purchase_order_createdAt"
    },
    {
        label: "Ordered SKUs & Qty Table",
        key: "order_sku_qty_table"
    },
    {
        label: "Purchase Order Progress in %",
        key: "purchase_order_progress"
    },
    {
        label: "Purchase Order Status",
        key: "purchase_order_status"
    },
]

export const todo_constants = [
    {
        label: "To Do Name",
        key: "todo_name"
    },
    {
        label: "To Do Status",
        key: "todo_status"
    },
    {
        label: "To Do Assignee",
        key: "todo_assignee"
    },
    {
        label: "Link to To Do",
        key: "todo_link"
    },
    {
        label: "To Do Completed Date",
        key: "todo_completed_date"
    },
    {
        label: "To Do End Date",
        key: "todo_end_date"
    },
    {
        label: "To Do Remarks",
        key: "todo_remarks"
    },
    {
        label: "Todo Tracking",
        key: "todo_tracking"
    }
]